import { LanguageType, ERPSystem } from '../../../../types';

type CountryOption = {
  label: string;
  value: ERPSystem;
};

type LanguageOption = {
  label: string;
  value: LanguageType;
};

const COUNTRY_SELECTOR_MAP: { [k: string]: CountryOption } = {
  NL: {
    label: 'Netherlands',
    value: 'NL',
  },
  BE: {
    label: 'Belgium',
    value: 'BE',
  },
  FR: {
    label: 'France',
    value: 'FR',
  },
  CH: {
    label: 'Switzerland',
    value: 'CH',
  },
  DE: {
    label: 'Germany',
    value: 'DE',
  },
};

// these strings are not to be translated
const LANGUAGE_SELECTOR_MAP: { [k: string]: LanguageOption } = {
  '31': {
    label: 'Nederlands',
    value: 'nl',
  },
  '-1': {
    label: 'English',
    value: 'en',
  },
  '-2': {
    label: 'Français',
    value: 'fr',
  },
  '-3': {
    label: 'Deutsch',
    value: 'de',
  },
};

export { COUNTRY_SELECTOR_MAP, LANGUAGE_SELECTOR_MAP };
